import script from "./WegowIconButton.vue?vue&type=script&setup=true&lang=js"
export * from "./WegowIconButton.vue?vue&type=script&setup=true&lang=js"

import "./WegowIconButton.vue?vue&type=style&index=0&id=7bf27386&scope=true&lang=scss"

const __exports__ = script;

export default __exports__